import React from 'react';
import Button from '@dbk/ui-buttons';
import TableRow from '../../../components/common/table-row';
import { DOC_UPLOAD } from '../../../../src/constants';
import { TextArea } from '@dbk/ui-forms';

const UploadHistoryListItemBody = (props) => {
  const contentType = props.data.contentType;
  let status = '';

    if (props.statuses) {
      props.statuses.map((item, i) => {
            if (item.id === props.data.status) {
                status = item.text;
            }
        })
    }
    
  return (
    <div>
      <div className="doc-upload-history-list-item-body">
        <div>
          <TableRow>

            {/* <TableRow.Column align="left" style={{maxWidth:'200px'}}> */}
            {/* <TableRow> */}
            <TableRow.Column align="left" width={0.25} style={{ marginTop: '10px' }} >
              <span className="data-wrapper-rm-name rm-name-header">
                <span className="list-item-body-message-header"> {props.messages['app.documentUploadHistory.accordion.rmNameHeader']}</span>
                
                <TableRow.Column align="left">
                  <span className="message-header-item">
                    {props.data.adminEmailId}
                  </span>
                </TableRow.Column>
              </span>
            </TableRow.Column>

            <TableRow.Column align="left">
              <span className="data-wrapper-message rm-name-header">
                <span className="list-item-body-message-header">{props.messages['app.documentUploadHistory.accordion.messageHeader']}</span>
                <TableRow.Column align="left">
                  <TextArea
                      testID="field_rm_msg_InputTextField_test"
                      accessibilityLabel="field_rm_msg_InputTextField_test"
                      className="upload-history-fixed-textArea"
                      name="remarks"
                      value={props.data.clientMsg}
                      autoCorrect={false}
                      zIndex={-1}
                      readOnly
                      autoCapitalize='none'
                      keyboardType="remarks"
                      selectTextOnFocus={false}
                      caretHidden={false}
                      maxlength={DOC_UPLOAD.TEXTAREA_MAXLENGTH}
                      contextMenuHidden={false}
                    />
                </TableRow.Column>
              </span>
            </TableRow.Column>
            <div className="doc-upload-history-list-item-body-btns">
              <div className="view-document-btn">
                <Button tertiary size="large"
                  className="view-document-button-layout"
                  testID="btn_uploadHistory_viewDocument_test"
                  disabled={contentType && contentType !== DOC_UPLOAD.DOC_TYPE || status === "Failed"}
                  accessbilityLabel="btn_uploadHistory_viewDocument_test"
                  onClick={() => props.onViewDocClick(props.data.docId, props.data.docusafeDocId, props.data.contract)}>
                  {props.messages['app.documentUploadHistory.accordion.messageHeaderItem.viewDocumentButton']}
                </Button>
              </div>
              <div className="download-btn-layout">
                <Button className="download-button-layout"
                  size="large"
                  testID="btn_uploadHistory_downloadDocument_test"
                  disabled={status === "Failed"}
                  accessbilityLabel="btn_uploadHistory_downloadDocument_test"
                  onClick={() => props.onDownloadClick(props.data.docId, props.data.docusafeDocId, props.data.contract)}>
                  {props.messages['app.documentUploadHistory.accordion.messageHeaderItem.downloadButton']}
                </Button>
              </div>
            </div>
          </TableRow>
          {/* </TableRow.Column>
                        </TableRow> */}

        </div>

      </div>
    </div>
  );
}
export default UploadHistoryListItemBody;